import { useTranslation } from 'react-i18next';

const useCommonTranslationInstance = () => {
    const { i18n } = useTranslation();
    return i18n;
};

export default useCommonTranslationInstance;
